import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = () => {
    return (
        <Svg width="123" height="24" viewBox="0 0 123 24" fill="none">
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.00475793 15.9373L1.8453 3.52103C1.91557 3.04536 2.28314 2.66833 2.75611 2.58455L17.3656 0.00887184C17.8196 -0.0708579 18.1696 0.402115 17.9602 0.812926L13.8156 8.94401C13.6061 9.35482 13.9561 9.82779 14.4102 9.74806L18.2237 9.07509C18.7683 8.97914 19.1061 9.64806 18.7061 10.0305L4.2007 23.8427C3.78584 24.2372 3.11692 23.8278 3.28043 23.2791L5.27368 16.5764C5.39259 16.1778 5.0507 15.7954 4.64124 15.867L0.65611 16.5697C0.280435 16.6359 -0.0492948 16.3143 0.0061106 15.9373H0.00475793ZM9.02367 10.3305C9.73719 10.6102 10.1926 10.7886 10.0304 9.87103C9.74395 8.24266 8.21827 7.15076 6.62233 7.4332C5.02773 7.71428 3.96692 9.26157 4.25341 10.89C4.41557 11.8075 4.78179 11.4845 5.35746 10.9764C5.80206 10.5845 6.37232 10.0818 7.06827 9.95887C7.76422 9.8359 8.47097 10.1129 9.02367 10.3305Z"
                fill={ds.colorValue.icon.primary}
            />
            <Path
                d="M110.387 19.2595V4.7395H122.387V8.3195H114.687V10.3595H120.387V13.4995H114.687V15.6395H122.387V19.2595H110.387Z"
                fill={ds.colorValue.icon.primary}
            />
            <Path
                d="M93.3559 19.2595V4.7395H100.036C105.096 4.7395 108.756 7.4995 108.756 11.9395C108.756 16.4595 105.036 19.2595 100.096 19.2595H93.3559ZM99.3959 15.6395C102.056 15.6395 103.976 14.6995 103.976 11.9995C103.976 9.3395 102.216 8.3595 99.3759 8.3595H97.7359V15.6395H99.3959Z"
                fill={ds.colorValue.icon.primary}
            />
            <Path
                d="M74.8695 19.2595L80.9095 4.7395H86.3495L92.3695 19.2595H87.7495L86.6495 16.5395H80.4895L79.4295 19.2595H74.8695ZM81.6895 13.1995H85.4495L83.5495 8.4795L81.6895 13.1995Z"
                fill={ds.colorValue.icon.primary}
            />
            <Path
                d="M69.0785 19.5195C64.1385 19.5195 60.0785 16.4995 60.0785 12.0795C60.0785 7.91949 63.6985 4.47949 69.2385 4.47949C70.9185 4.47949 72.7785 4.83949 74.3185 5.69949L74.4385 10.2595C72.9985 8.95949 71.2985 8.21949 69.4985 8.21949C67.0585 8.21949 64.8585 9.65949 64.8585 11.9795C64.8585 14.3195 66.9985 15.7795 69.5385 15.7795C71.3385 15.7795 73.2385 15.0195 74.6985 13.6995L74.1585 18.1995C73.0385 19.0195 71.1585 19.5195 69.0785 19.5195Z"
                fill={ds.colorValue.icon.primary}
            />
            <Path
                d="M45.3676 19.2595V4.7395H52.4876C57.3276 4.7395 59.0076 7.1195 59.0076 9.3395C59.0076 11.3795 57.3876 13.1995 54.8276 13.8995L59.6676 19.2595H54.3276L50.0876 14.1795H49.7476V19.2595H45.3676ZM52.2476 11.0395C53.4676 11.0395 54.3876 10.4595 54.3876 9.5795C54.3876 8.6395 53.5076 8.0995 52.2476 8.0995H49.7476V11.0395H52.2476Z"
                fill={ds.colorValue.icon.primary}
            />
            <Path
                d="M26.8813 19.2595L32.9213 4.7395H38.3613L44.3813 19.2595H39.7613L38.6613 16.5395H32.5013L31.4413 19.2595H26.8813ZM33.7013 13.1995H37.4613L35.5613 8.4795L33.7013 13.1995Z"
                fill={ds.colorValue.icon.primary}
            />
        </Svg>
    );
};

export default SvgComponent;
